import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { AsteriskIcon } from '../Input/AsteriskIcon';
import { Stack } from '../Layout';
import { theme } from '../theme';
import { Tooltip } from '../Tooltip';
import { Text } from './Text';
export const TextWithDottedUnderline = styled(Text)`
  text-decoration: ${(props)=>props.underline ? 'underline' : 'none'};
  text-decoration-style: dotted;
  text-underline-offset: ${theme.spaces.x4};
  text-decoration-color: ${theme.colors.gray400};
`;
export const UnderlineHint = ({ hint, level = 'sm', tone = theme.colors.gray500, required = false, children, ...restProps })=>{
    let _hint;
    if (typeof hint === 'string') {
        _hint = {
            title: hint,
            overlayStyle: {
                maxWidth: '350px',
                maxHeight: '300px',
                overflow: 'auto'
            }
        };
    } else {
        _hint = hint;
    }
    return /*#__PURE__*/ _jsxs(Stack, {
        gap: theme.spaces.x2,
        direction: "horizontal",
        children: [
            required && /*#__PURE__*/ _jsx(AsteriskIcon, {}),
            /*#__PURE__*/ _jsx(Tooltip, {
                title: _hint?.title || '',
                ..._hint,
                children: /*#__PURE__*/ _jsx(TextWithDottedUnderline, {
                    underline: Boolean(_hint),
                    level: level,
                    ...restProps,
                    children: children
                })
            })
        ]
    });
};
